/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Style_PresetsInputs */

const en_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style presets`)
};

const ar_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنماط مسبقة`)
};

const bn_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টাইল প্রিসেট`)
};

const de_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stil-Presets`)
};

const es_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajustes de estilo`)
};

const fr_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préréglages de style`)
};

const pt_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinições de estilo`)
};

const zh_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风格预设`)
};

const tr_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stil ön ayarları`)
};

const ru_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль-пресеты`)
};

const pl_svchip_style_presets = /** @type {(inputs: Svchip_Style_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presety stylu`)
};

/**
* | output |
* | --- |
* | "Style presets" |
*
* @param {Svchip_Style_PresetsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_style_presets = /** @type {((inputs?: Svchip_Style_PresetsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Style_PresetsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_style_presets(inputs)
	if (locale === "bn") return bn_svchip_style_presets(inputs)
	if (locale === "de") return de_svchip_style_presets(inputs)
	if (locale === "es") return es_svchip_style_presets(inputs)
	if (locale === "fr") return fr_svchip_style_presets(inputs)
	if (locale === "pt") return pt_svchip_style_presets(inputs)
	if (locale === "zh") return zh_svchip_style_presets(inputs)
	if (locale === "tr") return tr_svchip_style_presets(inputs)
	if (locale === "ru") return ru_svchip_style_presets(inputs)
	if (locale === "pl") return pl_svchip_style_presets(inputs)
	return en_svchip_style_presets(inputs)
});